import React, { useEffect } from 'react';
import { Tabs, Card, Spin, Alert } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAnalyticsOverview } from '../../redux/slices.js/analytics/analyticsSlice';

const AnalyticsReportsPage = () => {
    const dispatch = useDispatch();
    const { overview, loading, error } = useSelector((state) => state.analytics);

    useEffect(() => {
        dispatch(fetchAnalyticsOverview());
    }, [dispatch]);

    return (
        <div style={{ padding: 24 }}>
            <h2>Analytics & Reports</h2>
            <Tabs defaultActiveKey="1" items={[
                {
                    key: '1',
                    label: 'Overview',
                    children: (
                        <Card>
                            <h3>Platform Activity</h3>
                            {loading && <Spin tip="Loading analytics..." />}
                            {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}
                            {overview && (
                                <div>
                                    <pre>{JSON.stringify(overview, null, 2)}</pre>
                                </div>
                            )}
                        </Card>
                    )
                },
                {
                    key: '2',
                    label: 'Monthly Active Users',
                    children: <Card><h3>Monthly Active Users</h3><div style={{ height: 200, background: '#f5f5f5', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Chart: Active users over time</div></Card>
                },
                {
                    key: '3',
                    label: 'Top Features',
                    children: <Card><h3>Top Used Features</h3><div style={{ height: 200, background: '#f5f5f5', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Chart: Feature usage (pie/bar)</div></Card>
                },
            ]} />
        </div>
    );
};

export default AnalyticsReportsPage; 